export default "__VITE_ASSET__CKYNJDLZ__"